import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import esTranslation from './locales/es-CO/translation.json';
import enTranslation from './locales/en-US/translation.json';
// Force HMR reload
import { iUserPermissions } from 'types/permissions';
import { getFromLocalStorage } from 'utils/localStorage/localStorage.utils';

const resources = {
  'es-CO': {
    translation: esTranslation,
  },
  'en-US': {
    translation: enTranslation,
  },
};

// Initialize i18n. Use an async IIFE to await `.init()` and avoid
// TypeScript overload/type incompatibilities while preserving runtime behavior.
(async () => {
  try {
    // cast options to `any` to avoid strict typing issues with the react options
    await i18n.use(initReactI18next).init(({
      resources,
      // Respect user preference: check custom key 'appLang' first, then i18next's stored key, then navigator, else default to 'es-CO'
      lng: (() => {
        if (typeof window === 'undefined') return 'es-CO';
        const storage = getFromLocalStorage('user') || getFromLocalStorage('i18nextLng');
        const preference = (storage as iUserPermissions)?.preferences || (typeof storage === 'string' ? { language: storage } : null);
        const nav = (navigator && (navigator.language || (navigator as any).userLanguage)) || '';
        const candidate = (preference?.language || nav || 'es-CO').toString();
        return candidate;
        // // Normalize common codes to our resource keys
        // if (candidate.startsWith('en')) return 'en-US';
        // if (candidate.startsWith('es')) return 'es-CO';
        // // Fallback to en-US if candidate contains 'en' anywhere
        // if (candidate.indexOf('en') !== -1) return 'en-US';
        // return 'es-CO';
      })(),
      fallbackLng: 'es-CO',
      ns: ['translation'],
      defaultNS: 'translation',
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false,
      },
    } as any));

    // Listen for user updates (login/preference changes) to sync language
    if (typeof window !== 'undefined') {
      window.addEventListener('localStorageUserUpdated', () => {
        const user = getFromLocalStorage<iUserPermissions>('user');
        if (user?.preferences?.language) {
          i18n.changeLanguage(user.preferences.language);
        }
      });
    }
  } catch (err: any) {
    console.error('[i18n] init error', err);
  }
})();

export default i18n;
